import { render, staticRenderFns } from "./editTime.vue?vue&type=template&id=b4cfab06&scoped=true"
import script from "./editTime.vue?vue&type=script&lang=js"
export * from "./editTime.vue?vue&type=script&lang=js"
import style0 from "./editTime.vue?vue&type=style&index=0&id=b4cfab06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4cfab06",
  null
  
)

export default component.exports